<template>
  <h1 style="padding: 20px; text-align: center">
    Oops, it looks like the page you're looking for doesn't exist.
  </h1>
</template>
